import { useCallback, useContext } from 'react';
import AppNavigateContext from '../context/AppNavigateContext';

/**
 * Navigate inside the app: through the router's navigate() when CRMApp provides it (no page reload), else a plain page
 * load (isolated component tests, previews). The same idea as AppLink, for code that navigates from a handler.
 */
export default function useAppNavigate() {
    const navigate = useContext(AppNavigateContext);
    return useCallback((to) => {
        if (typeof navigate === 'function') {
            navigate(to);
            return;
        }
        if (typeof window !== 'undefined') window.location.assign(to);
    }, [navigate]);
}
